// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__9tJ5y","inner":"Footer_inner__14m6b"};